import React, { useState, useEffect } from 'react';
import { Button, Image } from 'antd';
import QRCode from 'qrcode';
import styles from './index.module.scss';
import webinarModel1 from '@/assets/images/webinarModel-1.png';
import webinarModel2 from '@/assets/images/webinarModel-2.png';

const WebinarModal: React.FC = () => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>('');
  const registrationUrl = 'https://us06web.zoom.us/webinar/register/WN_zggU-hS_T_Wnk-eN-lHjUg';

  // 生成二维码
  useEffect(() => {
    const generateQRCode = async () => {
      try {
        const qrCodeUrl = await QRCode.toDataURL(registrationUrl, {
          width: 120,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });
        setQrCodeDataUrl(qrCodeUrl);
      } catch (error) {
        console.error('生成二维码失败:', error);
      }
    };

    generateQRCode();
  }, []);

  // 处理注册按钮点击
  const handleRegisterClick = () => {
    window.open(registrationUrl, '_blank');
  };

  // 处理URL点击
  const handleUrlClick = () => {
    window.open(registrationUrl, '_blank');
  };

  return (
    <div className={styles.webinarPage}>
      <div className={styles.container}>
        {/* 绿色头部区域 */}
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <div className={styles.title}>
              本周五美东下午6点，
            </div>
            <div className={styles.subtitle}>
              2026年奥巴马医保的新变化
            </div>
          </div>
          {/* 头部右侧图标占位div */}
          <div className={styles.headerIcons}>
            <Image
              width={253}
              src={webinarModel1}
              preview={false}
            />
          </div>
        </div>

        {/* 白色Body区域 */}
        <div className={styles.mainBody}>
          <div className={styles.bodyContent}>
            {/* 主讲人信息 */}
            <div className={styles.speakerInfo}>
              <p className={styles.speakerTitle}>
                主讲人：<span className={styles.speakerName}>David Wang博士</span>
              </p>
              <div className={styles.eventDetail}>
                When: Oct 24, 2025 06:00 PM Eastern Time (US and Canada)
              </div>
              <div className={styles.eventDetail}>
                Topic: Live Webinar with Dr. David Wang
              </div>
            </div>
            {/* 注册信息 */}
            <div className={styles.registrationInfo}>
              <div className={styles.registrationText}>
                Register in advance for this webinar:
              </div>
              <div className={styles.urlContainer}>
                <a
                  href={registrationUrl}
                  onClick={(e) => {
                    e.preventDefault();
                    handleUrlClick();
                  }}
                  className={styles.registrationUrl}
                >
                  {registrationUrl}
                </a>
                <span className={styles.limitText}>
                  (限制100人，先注册先得。)
                </span>
              </div>
              <div className={styles.confirmationText}>
                After registering, you will receive a confirmation email containing information about joining the webinar.
              </div>
            </div>

            {/* 注册按钮和二维码区域 */}
            <div className={styles.actionArea}>
              <div className={styles.buttonArea}>
                <Button
                  type="primary"
                  size="large"
                  onClick={handleRegisterClick}
                  className={styles.registerButton}
                >
                  立即注册
                </Button>
                <p className={styles.noteText}>
                  注:本场活动发言和提问均为中文，您可以点击"立即注册"或扫描右侧二维码注册会议，欢迎踊跃参与!
                </p>
              </div>

              {/* 二维码 */}
              <div className={styles.qrCodeArea}>
                {qrCodeDataUrl && (
                  <img
                    src={qrCodeDataUrl}
                    alt="注册二维码"
                    className={styles.qrCode}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={styles.bodyImage}>
            <Image
              preview={false}
              src={webinarModel2}
              width={537}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebinarModal;


